module.exports = __webpack_public_path__ + "res/whac_a_mole.8e677356f59a9932f832af26af53374a.webp";